<template>
  <div>
    <v-btn
      class="btn-download rounded-1"
      depressed
      outlined
      color="primary"
      height="24"
      width="100"
      @click="download"
    >
      Download
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.59253 11.2H11.7925V12H4.59253V11.2ZM8.59253 7.2H11.3925L8.19253 10.4L4.99253 7.2H7.79253V4H8.59253V7.2Z"
          fill="#029F48"
        />
      </svg>
    </v-btn>
  </div>
</template>

<script>
import { handleDownloadFile } from '../../utils/misc'

export default {
  name: 'DownloadButtonWithIcon',
  props: {
    file: {
      type: String,
      default: '',
    },
  },
  methods: {
    download() {
      handleDownloadFile(this.file)
      this.$emit('on-download')
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-download {
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  letter-spacing: 0.1px;
  text-transform: capitalize;
}
</style>
